module.exports = __webpack_public_path__ + "img/ar-qtv-2.15669c4a.webp";